<div class="panel-body" *ngIf="activeSection == 'officeAdmin'">
  <div class="form-horizontal">

    <fieldset class="content-group">
      <div class="form-group">
        <label class="control-label col-lg-2">Office Name*</label>
        <div class="col-lg-10">
          <input autocomplete="off" pattern="^[^<>]*$" type="text" [(ngModel)]="officeName" placeholder="Enter Office Name" class="form-control">
          <div *ngIf="formofficeNameError && errorOfficeName">
            <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formofficeNameError}}</span>
          </div>
        </div>
      </div>

      <div class="form-group">
        <div class="col-lg-12">
          <button (click)="saveOfficeName()" type="submit" class="btn pull-right btn-primary">
            <strong>Save</strong>
          </button>
        </div>
      </div>
    </fieldset>
  </div>
</div>

<div class="panel-body" *ngIf="activeSection == 'officeType'">
  <div class="form-horizontal">

    <fieldset class="content-group">
      <div class="form-group">
        <label class="control-label col-lg-2">Officer Contact*</label>
        <div class="col-lg-10">
          <input autocomplete="off" pattern="^[^<>]*$" type="number" [(ngModel)]="userDetails['contact']" placeholder="Enter Officer Contact Number" class="form-control">
          <div *ngIf="formErrorContact && error">
            <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorContact}}</span>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="control-label col-lg-2">Officer Region*</label>
        <div class="col-lg-10">
          <input autocomplete="off" pattern="^[^<>]*$" type="text" [(ngModel)]="userDetails['region']" placeholder="Enter Officer Region Name" class="form-control">
          <div *ngIf="formErrorRegion && error">
            <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorRegion}}</span>
          </div>
        </div>
      </div>

      <div class="form-group">
        <div class="col-lg-12">
          <button (click)="validateUser()" type="submit" class="btn pull-right btn-primary">
            <strong>Save</strong>
          </button>
        </div>
      </div>
    </fieldset>
  </div>
</div>
